import { isBrowser } from '../config'
import { escapeHtml } from '../utils'

const globalMvtCampaignTemp = isBrowser && window.__MVTCAMPAIGN__
const globalMvtVariantTemp = isBrowser && window.__VARIANT__
const globalRecommendationIdTemp = isBrowser && window.__RECOMMENDATION_ID__
let globalMvtVariant = globalMvtVariantTemp

export function getVariant (variant) {
  if (!isBrowser) {
    return variant
  }
  return globalMvtVariant
}

export function changeMVTVariables (location) {
  if (isBrowser && window.__SSR_PATH__ !== escapeHtml(location.pathname)) {
    window.__MVTCAMPAIGN__ = undefined
    globalMvtVariant = undefined
    window.__VARIANT__ = undefined
    window.__RECOMMENDATION_ID__ = 'undefined'
  }
  if (isBrowser && window.__SSR_PATH__ === escapeHtml(location.pathname)) {
    window.__MVTCAMPAIGN__ = globalMvtCampaignTemp
    globalMvtVariant = globalMvtVariantTemp
    window.__VARIANT__ = globalMvtVariantTemp
    window.__RECOMMENDATION_ID__ = globalRecommendationIdTemp
  }
}
